import { render, staticRenderFns } from "./EMButton.vue?vue&type=template&id=2626f324&"
import script from "./EMButton.vue?vue&type=script&lang=js&"
export * from "./EMButton.vue?vue&type=script&lang=js&"
import style0 from "./EMButton.vue?vue&type=style&index=0&id=2626f324&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
